import React from "react";
import { Empty, Spin } from "antd";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import ActivityTimeline from "./ActivityTimeline";
import { MOCK_ACTIVITY_GROUPS } from "./mockActivityData";

const BatteryActivityLogModal = ({
  visible,
  onClose,
  activityGroups = MOCK_ACTIVITY_GROUPS,
  loading = false,
}) => {
  return (
    <CustomModal visible={visible} onCancel={onClose} width="840px">
      <div
        className="rounded-xl bg-background-white w-full overflow-hidden"
        style={{
          boxShadow:
            "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-4">
          <h2 className="font-poppins font-medium text-base text-[#000000]">
            Activity Log
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-md border border-light-grey flex items-center justify-center bg-white hover:bg-background-grey cursor-pointer transition-colors"
          >
            <CloseIcon strokeWidth={2} className="w-4 h-4 stroke-[#525252]" />
          </button>
        </div>

        <div className="w-full h-[1px] bg-light-grey" />

        {/* Modal Body */}
        <div className="px-6 pb-4 max-h-[75vh] overflow-y-auto">
          {loading && (
            <div className="flex items-center justify-center py-12">
              <Spin />
            </div>
          )}

          {!loading && activityGroups.length === 0 && (
            <Empty
              className="py-12 "
              description={
                <div className=" text-center text-xs font-poppins text-[#525252]">
                  No activity recorded in the last 30 days
                </div>
              }
            />
          )}

          {!loading && activityGroups.length > 0 && (
            <ActivityTimeline groups={activityGroups} />
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default BatteryActivityLogModal;
